export default __webpack_public_path__ + "static/media/IncSelectedDataSortIcon.5486b67d.svg";